import { Helmet } from 'react-helmet-async';

const defaults = {
  title: 'SurfSwell.ai',
  titleTemplate: '%s | SurfSwell.ai',
  description: 'SurfSwell.ai is your AI-powered surf coach. Get personalized coaching, check live surf conditions, log sessions, track your progress, and connect with your crew.',
  url: 'https://surfswell.ai',
  image: 'https://surfswell.ai/apple-touch-icon.png',
};

export default function SEO({ title, description, path }) {
  const pageTitle = title || defaults.title;
  const pageDesc = description || defaults.description;
  const pageUrl = path ? `${defaults.url}${path}` : defaults.url;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
    </Helmet>
  );
}
